import { filter } from '@exodus/atoms';
export default function createWalletAccountsAtom({ walletAccountsInternalAtom, }) {
    return filter(walletAccountsInternalAtom, (value) => !!value);
}
